import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import ExportLabel from '../../components/common/ExportLabel/Export';
import SearchBox from '../../components/common/Search/SearchBox';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import { baseurl } from '../../api';
import { useCheckboxClick } from '../../checkboxclick';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
const pageKey = "payments"

const Payments = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [items, setItems] = useState([]);
  const location = useLocation();
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const { organizationId = null, fromSubscriptions = false } = location.state || {};
  const navigate = useNavigate();
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest',];
  const searchCategories = ['Refference id','Subscription','Customer'];
  const filterOptions = ['Default', 'UPI', 'Bank', 'Archived', 'Unarchived'];
  const [exportState, setExportState] = useState({
    isExporting: false,
    error: null
  });
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);


  const fetchPayments = async () => {
    try {
      const params = {
        search: searchParams.term,
        search_argument: searchParams.argument,
        filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
        sort: mapSortOptionToQuery(selectedSortOption),
      };
  
      const baseUrl = `${baseurl}subscriptions/payment/`;
      const url = fromSubscriptions && organizationId
        ? `${baseUrl}?organization=${organizationId}`
        : baseUrl;
  
      const response = await authenticatedAxios.get(url, { params });
  
      if (response.data.response_code === 1) {
        setItems(response.data.data);
      } else {
        console.error('Unexpected response code:', response.data.response_code);
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error('Error fetching payments:', error);
      }
    }
  };
  

  useEffect(() => {
    fetchPayments();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedSortOption, organizationId, fromSubscriptions]);



  const handleArchiveSelectedItems = async (action) => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}subscriptions/payment/archive/`, {
        id_list: selectedItems,
        action, // Use action to specify archive/unarchive
      });

      if (response.status >= 200 && response.status < 300) {
        await fetchPayments();
        resetCheckboxState(); // Clear selection
      } else {
        console.error('Failed to archive/unarchive selected items.');
      }
    } catch (error) {
      console.error('Error archiving/unarchiving selected items:', error);
    }
  };

  const handleSearchSelect = (searchCategory, searchTerm) => {
    setSearchParams({
      term: searchTerm,
      argument: searchCategory.toLowerCase(),
    });
  };

  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      case 'Bank':
        return 'Bank';
      case 'UPI':
        return 'UPI';
      default:
        return 'newest';

    }
  };

  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };

  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
  };
  const handleExportStart = () => {
    setExportState({ isExporting: true, error: null });
  };

  const handleExportComplete = () => {
    setExportState({ isExporting: false, error: null });
    resetCheckboxState();
  };

  const handleExportError = (error) => {
    setExportState({ isExporting: false, error });
  };

  return (
    <div className='whole-container'>
      <div className='top-heading'>
        <PageHeader pageName="Subscription /" nestedpageName="Payments"  linkTo="" /> 
        <div className='export-container'>
        <ArchiveSelectedItem
          selectedItems={selectedItems}
          items={items}
          onArchiveSelected={handleArchiveSelectedItems}
        />
          <ExportLabel
            exportUrl={`${baseurl}subscriptions/payment/export/`}
            selectedIds={selectedItems}
            onExportStart={handleExportStart}
            onExportComplete={handleExportComplete}
            onExportError={handleExportError}
          />
        </div>
      </div>
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>Payments</h1>
        </div>
        <div className='pagename-right-container'>
          <SearchBox categories={searchCategories} onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term} />
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption}/>
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
        </div>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />Reference Id
              </th>

              <th>Subscription</th>
              <th>Customer Name</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Payment Method</th>
            </tr>
          </thead>
          <tbody className='common-table-tbody'>
            {items.length > 0 ? (
              items.map((payment) => (
                <tr key={payment.id}>
                  <td className='d-flex ai-center'>
                    <input
                      className="table-selectbox table-child-selectbox"
                      type="checkbox"
                      checked={selectedItems.includes(payment.id)}
                      onChange={() => handleChildCheckboxChange(payment.id)}
                    />{payment.reffernce_id}
                  </td>
                  <td>{payment.subscription?.subscription_code || 'N/A'}</td>
                  <td>{payment.organization?.name || 'N/A'}</td>
                  <td>{payment.amount}</td>
                  <td>{new Date(payment.date).toLocaleDateString()}</td>
                  <td>{payment.payment_method}</td>
                </tr>               
              ))
            ) : (
              <tr>
                <td colSpan="6">No payments found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Payments;
